
import { defineComponent, PropType } from 'vue';
import { PlatformLog, PlatformLogStats } from '@/interfaces/panel/platform-logs.model';

export default defineComponent({
  name: 'PlatformLogsTable',
  props: {
    logs: {
      type: Array as PropType<PlatformLog[]>,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    stats: {
      type: Object as PropType<PlatformLogStats>,
      required: true,
    },
  },
  emits: ['view-details'],
  setup() {
    const headers = [
      { title: 'نوع', value: 'type', sortable: false, key: 'type' },
      { title: 'وضعیت', value: 'status', sortable: false, key: 'status' },
      { title: 'اکشن', value: 'action', sortable: false, key: 'action' },
      { title: 'کاربر', value: 'user', sortable: false, key: 'user' },
      { title: 'ادمین', value: 'admin', sortable: false, key: 'admin' },
      { title: 'کاربر هدف', value: 'targetUser', sortable: false, key: 'targetUser' },
      { title: 'مبلغ', value: 'amount', sortable: false, key: 'amount' },
      { title: 'موجودی قبل', value: 'previousBalance', sortable: false, key: 'previousBalance' },
      { title: 'موجودی جدید', value: 'newBalance', sortable: false, key: 'newBalance' },
      { title: 'توضیحات', value: 'description', sortable: false, key: 'description' },
      { title: 'IP', value: 'ipAddress', sortable: false, key: 'ipAddress' },
      { title: 'دستگاه', value: 'device', sortable: false, key: 'device' },
      { title: 'تاریخ', value: 'createdAt', sortable: false, key: 'createdAt' },
      { title: 'عملیات', value: 'actions', sortable: false, key: 'actions', align: 'center' as const },
    ];

    const getTypeColor = (type: string) => {
      const colors: Record<string, string> = {
        USER_ACTION: 'blue',
        ADMIN_ACTION: 'purple',
        SYSTEM_ACTION: 'grey',
        FINANCIAL: 'green',
        SECURITY: 'red',
      };
      return colors[type] || 'grey';
    };

    const getTypeLabel = (type: string) => {
      const labels: Record<string, string> = {
        USER_ACTION: 'کاربر',
        ADMIN_ACTION: 'ادمین',
        SYSTEM_ACTION: 'سیستم',
        FINANCIAL: 'مالی',
        SECURITY: 'امنیتی',
      };
      return labels[type] || type;
    };

    const getStatusColor = (status: string) => {
      const colors: Record<string, string> = {
        SUCCESS: 'success',
        FAILED: 'error',
        PENDING: 'warning',
      };
      return colors[status] || 'grey';
    };

    const getStatusLabel = (status: string) => {
      const labels: Record<string, string> = {
        SUCCESS: 'موفق',
        FAILED: 'ناموفق',
        PENDING: 'در انتظار',
      };
      return labels[status] || status;
    };

    const formatAmount = (amount: string) => {
      return new Intl.NumberFormat('fa-IR').format(Number(amount));
    };

    const formatDate = (dateString: string) => {
      const date = new Date(dateString);
      return new Intl.DateTimeFormat('fa-IR', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
      }).format(date);
    };

    return {
      headers,
      getTypeColor,
      getTypeLabel,
      getStatusColor,
      getStatusLabel,
      formatAmount,
      formatDate,
    };
  },
});
